export { Platform } from './platform';
export { getSupportedInputTypes } from './features';



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/core/platform/index.js
// module id = 1378
// module chunks = 31